import React, { useState } from "react";

import "./home.css"

import PrimarySearchAppBar from "../../Components/NavBar";
import HomeButton from "../../Components/HomeButton";
import Partners from "../../Components/Partners";
import Footer from "../../Components/Footer";

const DesktopComponent = () => {

    return (
    <>

    <div className="section-1" id="home">
      <div style={ { padding: "1rem" } }>
        <PrimarySearchAppBar />
      </div>
      <div className="logo">
        <img src="/REWARDS COIN.png" alt="logo" className="logo" />
        <p style={ { margin: "30px 20% 2rem 20%", fontSize: "20px", opacity: "0.7" } }>
        No need of staking, No need of claiming!
Recieve BNB rewards directly on the wallet where you hold your REWARDScoin.</p>
        <HomeButton text="REWARDScoin Tracker"/>
      </div>
    </div>

    <div className="main" style={ { overflow: "hidden" } }>

      <div className="about-us" id="about">
        <div style={ { padding: "2rem 5% 2rem 10%", fontSize: "1.5rem" } }>
          <img src="/about us.png" alt="logo" className="about-us-img"/>
          <p >REWARDScoin is the newest and ultimate coin created with the purpose of maximizing the rewards for its holders. 
Based on Binance Smart Chain, REWARDScoin futures multiple rewards mechanisms that are activated by the REWARDScoin Wallets. Rewardscoin holders proportionally will receive the entire 8% BNB rewards from the tax fee applied on transactions. All this whilst the REWARDScoin Deployer will be performing buy-backs and burns making REWARDScoin more rare and of greater value.</p>
        </div>
        <img style={ { padding: "0 7% 0 0", width: "23%" }} src="/web.gif" alt="logo" className="binance-coin" />
      </div>

      <div className="tokenomics" id="tokenomics">
        <div style={ { fontSize: "20px", padding: "2rem 12rem 0rem 7rem", width: "70%" } }>
          <img src="/token information.png" alt="logo" className="tokenomics-img" />
          <div>
            <p style={ { marginTop: "1.5rem" }  } >
            <p><span style={ { fontWeight: "bold" } } >REWARDScoin DEPLOYER: </span> Daily Buy-back and burn.</p>

            <p><span style={ { fontWeight: "bold" } } >REWARDScoin POOL: </span>Staking the BNB rewards, which will be invested in DeFi partners/projects, paying out a weekly dividend, proportionally to all the holders that hold a minimum amount of 1,000 REWARDScoin in a unique wallet address.</p>

            <p><span style={ { fontWeight: "bold" } } >REWARDScoin VAULT: </span>Daily BNB rewards, incentives and contests.</p>

            <p><span style={ { fontWeight: "bold" } } >REWARDScoin TEAM : </span>Development, marketing and rewards.</p>
          </p>
          <HomeButton text="Earn Rewards"/>
          </div>
        </div>
        <div className="token-info-parent" >
          <div className="token-info">
            <img src="/tokenomics.png" alt="logo" className="token-info-img" />
            <div style={ { lineHeight: "12px", marginTop: "60px",  opacity: "0.7", fontSize: "20px" } }>
                <p><span style={ { fontWeight: "bold" } }>Token name:</span> REWARDS COIN</p>
                <p><span style={ { fontWeight: "bold"} }>Token Address:</span><span style={ { lineHeight: "24px" } }> 0x434d9BA4A56469c90C0EBd0BE56cd46Dc8cf75d5</span></p>
                <p><span style={ { fontWeight: "bold" } }>Symbol:</span> 1RC</p> 
                <p><span style={ { fontWeight: "bold" } }>Decimals:</span> 18</p> 
                <p><span style={ { fontWeight: "bold" } }>Supply:</span> 100,000,000</p> 
                <p><span style={ { fontWeight: "bold" } }>Tax:</span> 8%</p>
                <p><span style={ { fontWeight: "bold" } }>8% BNB Rewards</span></p>
                <p><span style={ { fontWeight: "bold" } }>Smart Chain:</span> BSC</p>
            </div>
            <div style={ { lineHeight: "10px", margin: "50px 0 100px 0" } }>
              <h4 style={ { color: "#D0F1FF"} }>PINKSALE PRESALE</h4> 
              <h4 style={ { color: "#D0F1FF"} }>HARD CAP: 160 BNB</h4> 
              <h4 style={ { color: "#D0F1FF"} }>SOFT CAP: 80 BNB</h4> 
            </div>
            <img  className="alien" src="/logo.png" alt="logo" />
          </div>
        </div>
      </div>

      <div id="whitepaper" className="whitepaper" style={ {width: "100%", display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", padding: "3rem" }  }>
        <img  src="/whitepaper.png" alt="whitepaper"  style={  { width: "20%", maxWidth: "400px", margin: "1.5rem 0" } } />
        <a href="https://rewards-coin.gitbook.io/rewardscoin-whitepaper/" target="_blank" rel="noreferrer"><HomeButton text="Download" /></a>
      </div>

      <div id="audit" className="audit" style={ { margin: "2rem 0", display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", padding: "5rem" }  }>
        <img  src="/audit.png" alt="audit"  style={  { width: "42%", maxWidth: "200px", marginBottom: "2rem" } } />
        <p style={ { fontSize: "1rem", textAlign: "center", lineHeight: "0.2" } }>✅ Doesn't appear to be a honey pot.</p>
        <p style={ { fontSize: "1rem", textAlign: "center", lineHeight: "0.2" } }>✅ Can't suspend trading.</p>
        <p style={ { fontSize: "1rem", textAlign: "center", lineHeight: "0.2" } }>✅ No blacklist function.</p>
        <p style={ { fontSize: "1rem", textAlign: "center", lineHeight: "0.2" } }>✅ You may sell all tokens at once.</p>
        <p style={ { fontSize: "1rem", textAlign: "center", lineHeight: "0.2" } }>✅ Contract source vode verified.</p>
        <p style={ { fontSize: "1rem", textAlign: "center", lineHeight: "0.2", marginBottom: "3rem" } }>✅ No mint function.</p>
        <a href="https://github.com/CFG-NINJA/audits/blob/3b91aca0c5b3430d84e72615dd63e3369b7f2f40/20221222_CFGNINJA_REWARDS%20COIN_Audit.pdf" target="_blank" rel="noreferrer"><HomeButton text="Audit Info" /></a>
      </div>

      <div className="roadmap" id="roadmap">
        <div style={ { padding: "2rem 5% 2rem 10%", fontSize: "1.5rem" } }>
          <img style={ { width: "100%" } } src="/roadmap text.png" alt="logo" className="roadmap-img"/>
        </div>
        <div className="roadmap-info">
          <div>
            <img src="/roadmap.png" alt="logo" className="roadmap-info-img" />
          </div>
          <div className="roadmap-text foundation">
            <h3 style={ { color: "#F3BA2F", fontSize: "28px", whiteSpace: "nowrap" } }>STAGE 1</h3>
            <p>● Core branding and web development</p>
            <p>● Presale Round</p>
            <p>● Listing on PCS</p>
            <p>● Major burn events</p>
            <p>● Community giveaways and &nbsp;&nbsp;&nbsp;development</p>
          </div>
          <div className="roadmap-text decentraization">
            <h3 style={ { color: "#F3BA2F", fontSize: "28px", whiteSpace: "nowrap" } }>STAGE 2</h3>
            <p>● 1RC DAPP</p>
          </div>
          <div className="roadmap-text smart-contracts">
            <h3 style={ { color: "#F3BA2F", fontSize: "28px", whiteSpace: "nowrap" } }>STAGE 3</h3>
            <p>● 1RC SWAP</p>
          </div>
          <div className="roadmap-text scaling">
            <h3 style={ { color: "#F3BA2F", fontSize: "28px", whiteSpace: "nowrap" } }>STAGE 4</h3>
            <p>● 1RC WALLET</p>
          </div>
          <div className="roadmap-text governance">
            <h3 style={ { color: "#F3BA2F", fontSize: "28px", whiteSpace: "nowrap" } }>STAGE 5</h3>
            <p>● 1RC MINING NFTS</p>
          </div>
          <div className="roadmap-text section6">
            <h3 style={ { color: "#F3BA2F", fontSize: "28px", whiteSpace: "nowrap" } }>STAGE 6</h3>
            <p>TBA</p>
          </div>
        </div>
      </div>
      <Partners />

      <img src="/logo.png" alt="logo" style={ { width: "30%", maxWidth: "400px", minWidth: "200px" } } />
    </div>

    <Footer />
    </>
    );
};

export default DesktopComponent;
